<template>
    <ui-badge v-if="classification !== null" :class="badgeClasses" :variant="badgeVariant">
        <div class="d-flex align-items-center">
            <component v-if="icon" :is="icon" />
            <div :class="{'ml-2': icon}">
                {{text}}
            </div>
        </div>
    </ui-badge>
</template>

<script>
import { nudityClassificationValidator } from "../../utils";
import { NUDITY_CLASSIFICATION, NUDITY_CLASSIFICATION_TEXT_MAP, NUDITY_CLASSIFICATION_TYPE_MAP } from "../../constants";

export default {
    name: "BadgeNudityClassification",
    components: {
        UiBadge: () => import(/* webpackChunkName: "chunk-ui-badge" */ "../ui/ui-badge.vue"),
        SvgCheckMark: () => import(/* webpackChunkName: "chunk-svg-check-mark" */ "../svg/checkmark.vue"),
        SvgXIcon: () => import(/* webpackChunkName: "chunk-svg-x-icon" */ "../svg/x-icon.vue"),
    },
    props: {
        classification: {
            type: [Number, null],
            default: null,
            validator: nudityClassificationValidator
        },
        size: {
            type: String,
            default: "md",
            validator: (value) => ["xl", "md"].includes(value)
        },
        useUploaderBadge: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        badgeClasses() {
            return {
                nudity_classification_badge: true,
                [`nudity_classification_badge-${this.type}`]: true,
                "uploader-badge": this.useUploaderBadge
            }
        },
        badgeVariant() {
            switch (this.classification) {
                case NUDITY_CLASSIFICATION.SAFE:
                case NUDITY_CLASSIFICATION.HOT:
                    return "success";
                case NUDITY_CLASSIFICATION.UNIDENTIFIED:
                    return "light";
                case NUDITY_CLASSIFICATION.HARD:
                    return "danger";
            }
        },
        icon() {
            if (!this.useUploaderBadge) {
                switch (this.classification) {
                    case NUDITY_CLASSIFICATION.SAFE:
                    case NUDITY_CLASSIFICATION.HOT:
                        return "svg-check-mark";
                    case NUDITY_CLASSIFICATION.HARD:
                        return "svg-x-icon";
                }
            }
        },
        text() {
            if (!this.useUploaderBadge) {
                switch (this.classification) {
                    case NUDITY_CLASSIFICATION.SAFE:
                        return gettext("Recommended");
                    case NUDITY_CLASSIFICATION.HOT:
                        return gettext("Accepted");
                    case NUDITY_CLASSIFICATION.HARD:
                        return gettext("Not accepted");
                }
            }
            return NUDITY_CLASSIFICATION_TEXT_MAP[this.classification];
        },
        type() {
            return NUDITY_CLASSIFICATION_TYPE_MAP[this.classification];
        }
    }
}
</script>
<style>
.nudity_classification_badge {
    border-radius: var(--border-radius);
    font-size: var(--font-size-small-medium);
    font-style: normal !important;
    line-height: 20px !important;
    margin-bottom: 0;
    padding: 4px 8px !important;
}
.nudity_classification_badge.uploader-badge {
    position: absolute;
    right: 0.5rem;
    bottom: 0.5rem;
    padding: 0.25rem 0.5rem !important;
}
.nudity_classification_badge.badge-success {
    border: 1px solid var(--color-success-200) !important;
    background-color: var(--color-success-100) !important;
    color: var(--color-success-950) !important;
}
.nudity_classification_badge.badge-success:not(.uploader-badge) {
    color: var(--color-success-800) !important;
}
.nudity_classification_badge.badge-light {
    border: 1px solid var(--color-gray-200) !important;
    background-color: var(--color-gray-100) !important;
    color: var(--color-gray-800) !important;
}
.nudity_classification_badge.badge-danger {
    border: 1px solid var(--color-primary-300) !important;
    background-color: var(--color-error-200) !important;
    color: var(--color-error-800) !important;
}
</style>